module.exports = __webpack_public_path__ + "static/media/candy.a0bc0bc0.jpg";